import { useToggle } from '@commenda/kakashi';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { FormBuilderHook } from '../../hooks/useFormBuilder';
import type { ComponentTemplate } from '@commenda/types';
import DraggableComponent from './DraggableComponent';

interface ComponentCategoryProps {
  category: {
    id: string;
    name: string;
    components: ComponentTemplate[];
  };
  defaultExpanded?: boolean;
  formBuilder?: FormBuilderHook;
  onComponentAdded?: (id: string) => void;
}

export default function ComponentCategory({
  category,
  defaultExpanded = true,
  formBuilder,
  onComponentAdded,
}: ComponentCategoryProps) {
  const isExpanded = useToggle(defaultExpanded);

  return (
    <div className="mb-2">
      <button
        type="button"
        onClick={() => isExpanded.toggle()}
        className="flex items-center justify-between w-full px-2 py-2 hover:bg-bg-secondary rounded-lg"
      >
        <span className="txt-small-medium text-text-secondary">
          {category.name}
        </span>
        {isExpanded.value ? (
          <ChevronDown className="w-4 h-4 text-text-tertiary" />
        ) : (
          <ChevronRight className="w-4 h-4 text-text-tertiary" />
        )}
      </button>
      {isExpanded.value && (
        <div className="mt-2 flex flex-col gap-2">
          {category && category.components.length > 0 ? (
            category.components.map((template) => (
              <DraggableComponent
                key={`${template.type}-${template.name}`}
                template={template}
                formBuilder={formBuilder}
                onComponentAdded={onComponentAdded}
              />
            ))
          ) : (
            <p className="txt-xs-regular text-text-tertiary">
              No components found
            </p>
          )}
        </div>
      )}
    </div>
  );
}
